<template>
  <div class="slider-block impact-module">
    <div class="inner">
      <div
        v-if="data.has_border"
        class="border"
      ></div>

      <div v-if="data.title" class="title">
        <div class="title-inner">
          <h2>{{ data.title }}</h2>
        </div>
      </div>

      <gallery class="gallery" v-if="hasGallery">
        <div class="slide" v-for="(slide, i) in data.slides" :key="i">
          <img :src="slide.image.poster" :alt="slide.image.alt">

          <p v-if="slide.eyebrow" class="eyebrow">{{ slide.eyebrow }}</p>
          <p v-if="slide.title" class="slide-title">{{ slide.title }}</p>
          <div v-if="slide.subtext" class="subtext" v-html="slide.subtext"></div>
        </div>
      </gallery>
    </div>
  </div>
</template>

<script>
import Gallery from '@/components/Gallery'

export default {
  name: 'SliderBlock',
  components: { Gallery },
  props: {
    data: Object
  },
  computed: {
    hasGallery() {
      return this.data.slides.length > 0
    }
  }
}
</script>

<style scoped>
.title {
  padding: 0 2rem;
}

/* .slider-block {
  padding-bottom: 10rem;
} */

.title h2 {
  font: var(--nord-title);
  text-align: center;
  margin-bottom: 4rem;
}

.slide {
  margin-left: 2rem;
}

.slide:last-of-type {
  padding-right: 2rem;
}

.slide img {
  border-radius: var(--br);
  margin-bottom: 1.5rem;
  height: 470px;
  width: auto;
}

.eyebrow {
  font: var(--nord);
  text-transform: uppercase;
}

.slide-title,
.subtext {
  font: var(--serif-small);
}

@media (max-width: 1000px) {

  .slide img {
    height: 230px;
  }
}
</style>